<div style="position: fixed;right: 0;height:100%;width:40%;">
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            <div class="row">
                <div class="col">Notification</div>
                <div class="col-auto link-dark cursor-pointer" (click)="ESS_NotificationInsertUpdate('All')">Read All
                </div>
            </div>

        </div>
        <div class="card-body p-1">
            <div class="row" style="display: contents;">
                <div class="col-12 p-0" >
                    <div class="tile m-1" *ngFor="let Notification of Notifications; let i = index">
                        <div class="row p-1 m-1 cursor-pointer"
                            [ngClass]="{'readbg': !Notification['IsRead'],'unreadbg':Notification['IsRead']}">
                            <div class="col-1">
                                <img [src]="common.PhotoLink('')" alt="user-image" width="35" class="rounded-circle">
                            </div>
                            <div class="col" (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'],true)">
                                <div class="title">
                                    <div class="row">
                                        <div class="col">{{Notification['Title']}}</div>
                                        <div class="col-auto badge danger" *ngIf="Notification['ImportantNotification']">Important</div>
                                    </div>
                                </div>
                                <div class="body">{{Notification['NotificationBody']}}</div>
                            </div>
                            <div class="col-auto">
                                <div ngbDropdown>
                                    <i role="button" class="bi bi-three-dots-vertical" id="Notificationaction"
                                        ngbDropdownToggle></i>
                                    <div ngbDropdownMenu aria-labelledby="Notificationaction" class="p-1"
                                        display="dynamic">
                                        <label class="Label cursor-pointer"
                                            (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'])">
                                            Mark as Read
                                        </label><br />
                                        <label class="Label cursor-pointer" (click)="ESS_NotificationInsertUpdate(Notification['WEBESSNotificationId'],true)">
                                            Action
                                        </label><br />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>